import React from 'react';
import { FilterToolbarButton } from '@components/ui/FilterMenu';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export interface ShowHiddenRowsToggleProps {
  on: boolean;
  onChange: (on: boolean) => void;
}

/**
 * "Show archived and snoozed" (GDN-3381).
 *
 * Only queues can hide a row, so only a queue shows this control. Off by
 * default: a hidden row is hidden because a biller decided about it, and the
 * queue's job is the work still outstanding. The check icon marks the on
 * state rather than a chevron, because nothing opens.
 */
export const ShowHiddenRowsToggle: React.FC<ShowHiddenRowsToggleProps> = ({ on, onChange }) => (
  <FilterToolbarButton
    aria-pressed={on}
    endIcon={on ? <CheckRoundedIcon sx={{ fontSize: '1rem !important' }} /> : null}
    onClick={() => onChange(!on)}
    selected={on}
  >
    Show archived and snoozed
  </FilterToolbarButton>
);
